import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 92,
	height: 88,
	viewBox: "0 0 92 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1107 78.2336C73.9964 85.1528 62.7232 87.9999 45.9992 87.9999C29.2752 87.9999 18.002 85.1528 10.8877 78.2336L45.9992 44L81.1107 78.2336Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8888 9.7666C3.79213 16.7031 0.87207 27.6944 0.87207 44.0002C0.87207 60.306 3.79213 71.2974 10.8888 78.2338L46.0003 44.0002L10.8888 9.7666Z",
			fill: "#F96955"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1115 9.7666L46 44.0002L81.1469 78.1821C88.2081 71.2629 91.1282 60.2888 91.1282 44.0692V43.9485C91.1282 27.6771 88.1904 16.6858 81.1115 9.7666Z",
			fill: "#72D4C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1107 9.76624C73.9964 2.84705 62.7232 0 45.9992 0C29.2752 0 18.002 2.84705 10.8877 9.76624L45.9992 43.9999L81.1107 9.76624Z",
			fill: "#005776"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.4871 87.3275H41.0457C40.267 87.3275 39.6299 86.7063 39.6299 85.9471V75.9566C39.6299 75.1973 40.267 74.5762 41.0457 74.5762H51.4871C52.2658 74.5762 52.9029 75.1973 52.9029 75.9566V85.9471C52.9029 86.7063 52.2658 87.3275 51.4871 87.3275Z",
			fill: "#005776"
		})
	]
});
export default SvgLogo;
